import query from './APIServices'

export interface Product {
  id: number
  name: string
  type: string
  salesCode: string
  showForSale: boolean
  stockLimit: boolean
  totalQuantity: string
  barCode: any
  qrCode: any
  measure: string
  alertLimit: any
  isAlertable: boolean
  isUnderAlertLimit: boolean
  isPublicVisible: boolean
  averageCost: string
  productCategoryId: any
  salesCategoryId: number
  createdAt: string
  supplierId: any
  groupName: any
  description: any
  groupConvertion: number
  enableGroup: any
  isWholesale: any
  visibleOnline: boolean
  availableForReservation: boolean
  alwaysAvailableForReservation: boolean
  reservationAvailableFrom: any
  reservationAvailableTo: any
  duration: any
  hasDuration: boolean
  onSale: boolean
  onSaleType: any
  onSaleDiscountAmount: any
  elaborationSteps: any
  netCost: string
  productCategory: any
  salesCategory: SalesCategory
  fixedCosts: any[]
  onSalePrice: any
  images: any[]
  resources: any[]
  prices: Price[]
  supplies: any[]
  attributes: any[]
}

export interface SalesCategory {
  id: number
  name: string
  description: string
  color: any
}

export interface Price {
  price: number
  isMain: boolean
  codeCurrency: string
  priceSystemId: number
}

export interface ProductsParams {
  page: number
  per_page: number
  search: string
  type?: string | string[]
}

export interface ProductsPostParams {
  name: string
  type: string
  prices: [{ price: number; codeCurrency: string }]
  salesCategoryId?: number
}

export const getProducts = async (params: ProductsParams) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([_, value]) => value != null)
  )
  console.log('getProducts params:', cleanParams)
  const response = await query.get('/administration/product/finder', {
    params: cleanParams,
  })
  console.log('getProducts response:', response?.data)
  // El nuevo endpoint podría devolver los datos directamente en response.data
  // en lugar de response.data.items
  return (response?.data.items || response?.data) as Product[]
}

export const postProducts = async (params: ProductsPostParams) =>
  await query.post('/administration/product', params)
